module.exports = __webpack_public_path__ + "media/images/ui-icons_444444_256x240-16fec672acf4e60b212d6f213cfea45d.png";